import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";
import routes from "../utils/routes";

const getAgencies = async () => {
    const response = await axiosInstance.get(paths.agencies);
    return response.data;
};

export const useAgencies = () => {
    const isSkippedRoute = () => {
        const path = window.location.pathname;
        return Object.values(routes.public).includes(path) || path === routes.private.sso_warning;
    };

    return useQuery({
        queryKey: ['agencies'],
        queryFn: getAgencies,
        enabled: !isSkippedRoute(),
        staleTime: 1000 * 60 * 60,
    });
};